import {
    Backdrop,
    BackdropProps,
    Box,
    InternalStandardProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { AppCircularProgress } from "./AppCircularProgress";
import { AppTypography } from "../AppTypography";

const StyledBackdropBox = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minWidth: "200px",
    background: `${theme.palette.background.default}`,
    padding: "20px",
}));

const StyledTypography = styled(AppTypography)(({ theme }) => ({
    color: `${
        theme.palette.mode === "light"
            ? theme.palette.text.primary
            : theme.palette.grey[200]
    }`,
    fontSize: "15px",
}));

export interface AppBackdropProgressProps
    extends InternalStandardProps<BackdropProps> {
    backdropText: string;
}

export const AppBackdropProgress = (props: AppBackdropProgressProps) => {
    const { className, ...rest } = props;

    return (
        <Backdrop
            {...rest}
            sx={{
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={true}
            onClick={() => {}}
        >
            <StyledBackdropBox>
                <AppCircularProgress />
                <Box height={10} />
                <StyledTypography>{props.backdropText}</StyledTypography>
            </StyledBackdropBox>
        </Backdrop>
    );
};
